import Box from "@mui/material/Box";
import type { ReactNode } from "react";

export type TabPanelProps = {
  children: ReactNode;
  value: number;
  index: number;
  id: string;
  labelledBy: string;
};

/**
 * Accessible tab panel (pairs with MUI `Tab` using matching `id` / `aria-controls`).
 * @see https://mui.com/material-ui/react-tabs/#accessibility
 */
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, id, labelledBy } = props;

  return (
    <Box
      role="tabpanel"
      id={id}
      aria-labelledby={labelledBy}
      hidden={value !== index}
    >
      {children}
    </Box>
  );
}
